import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import { setPayment } from '../../Actions/Checkout.action';
import Radio from './utils/Checkout.Radio';
import { translate } from '../../Services/translation';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const PaymentMethods = () => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { paymentMethods, selectedPaymentMethod } = checkout.payload;

  useEffect(() => {
    if (!selectedPaymentMethod) return;

    dispatch(setPayment(selectedPaymentMethod));
  }, []);

  return paymentMethods.length > 1 ? (
    <div className="grid grid-cols-1">
      {paymentMethods &&
        paymentMethods.map((method) => (
          <Radio
            key={method.id + 'payment-method'}
            title={method.name}
            description={method.description}
            cost={method.formattedPrice}
            logo={
              method.imageUrl ? (
                <img src={method.imageUrl} alt={method.name} />
              ) : (
                <Icon name="mail" className="h-6 w-6" />
              )
            }
            stateKey={'payment-method'}
            id={method.id}
            onChange={() => dispatch(setPayment(method))}
            checked={method.id === selectedPaymentMethod?.id}
          />
        ))}
    </div>
  ) : null;
};

export default PaymentMethods;
